/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroomndadescription4Inputs */

const en_coinvestments_dataroomndadescription4 = /** @type {(inputs: Coinvestments_Dataroomndadescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link your external data rooms and configure NDAs for your organisations. Set a default NDA that applies to all prospects, or upload custom NDAs for specific organisations.`)
};

/**
* | output |
* | --- |
* | "Link your external data rooms and configure NDAs for your organisations. Set a default NDA that applies to all prospects, or upload custom NDAs for specific ..." |
*
* @param {Coinvestments_Dataroomndadescription4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroomndadescription4 = /** @type {((inputs?: Coinvestments_Dataroomndadescription4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroomndadescription4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroomndadescription4(inputs)
});
export { coinvestments_dataroomndadescription4 as "coInvestments_dataRoomNdaDescription" }